import classNames from 'classnames'
import React, { Fragment } from 'react'

import './pill.scss'

import { StyledIcon, Text } from './pill.styles'

import type { Glyphs, FontAwesomeStyles } from '~/components/icon'

type Props = {
  iconGlyph?: Glyphs
  text?: string
  link?: string
  className?: string
  large?: boolean
  onClick?: () => void
  iconStyle?: FontAwesomeStyles
}

const Pill = ({
  iconStyle,
  iconGlyph,
  text,
  link,
  className,
  large,
  onClick,
}: Props) => {
  const IconGlyph = () =>
    iconGlyph ? <StyledIcon iconStyle={iconStyle} glyph={iconGlyph} /> : null

  const Element = onClick ? 'button' : 'div'

  return (
    <Element
      style={
        iconGlyph && !text
          ? {
              width: 20,
              padding: 0,
            }
          : {}
      }
      className={classNames('amp-pill', className, {
        large,
      })}
      onClick={onClick}
    >
      {link ? (
        <a href={link}>
          <IconGlyph />
          <Text>{text}</Text>
        </a>
      ) : (
        <Fragment>
          <IconGlyph />
          <Text>{text}</Text>
        </Fragment>
      )}
    </Element>
  )
}

export default Pill
